/**
 * ConsoleHub — PlayStation / hub mini-gier w domku (§13.2).
 * Kafle gier z mapy `gamesForHub('console')`; neutralne dla 5–7 lat.
 */
import Phaser from 'phaser';
import { BaseScene } from '../core/BaseScene.js';
import { UiKit, MIN_TOUCH } from '../core/UiKit.js';
import { getSceneRouter } from '../core/SceneRouter.js';
import { GAME_ICONS, launchConsoleGame, listConsoleGames } from './minigameMap.js';

export class ConsoleHubScene extends BaseScene {
  static readonly KEY = 'ConsoleHub';

  constructor() {
    super(ConsoleHubScene.KEY);
  }

  create(): void {
    // tło „pokoju" + ekran TV
    this.cameras.main.setBackgroundColor(0x2d2a3a);

    const cx = this.gameW / 2;
    const cy = this.gameH / 2;

    // półka
    this.add
      .rectangle(cx, this.gameH - 40, this.gameW * 0.9, 48, 0x6b5f7a)
      .setStrokeStyle(2, 0x4a3f55);

    // ramka TV
    const tvW = 900;
    const tvH = 520;
    this.add
      .rectangle(cx, cy - 20, tvW + 40, tvH + 40, 0x1a1824)
      .setStrokeStyle(6, 0x4a3f55);
    this.add
      .rectangle(cx, cy - 20, tvW, tvH, 0x1e3a5f)
      .setStrokeStyle(4, 0xbde0fe);

    // konsola + pad (placeholdery)
    this.add
      .text(cx - 200, this.gameH - 90, '🕹️', { fontSize: '40px' })
      .setOrigin(0.5);
    this.add
      .text(cx + 200, this.gameH - 90, '🎮', { fontSize: '40px' })
      .setOrigin(0.5);

    this.add
      .text(cx, 48, 'Konsola', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '36px',
        color: '#fff8f0',
        fontStyle: 'bold',
      })
      .setOrigin(0.5);
    this.add
      .text(cx, 88, 'Wybierz grę — dla wszystkich!', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '18px',
        color: '#bde0fe',
      })
      .setOrigin(0.5);

    const games = listConsoleGames();
    const cols = Math.min(games.length, 4);
    const tileW = 180;
    const tileH = Math.max(MIN_TOUCH + 40, 120);
    const gap = 24;
    const totalW = cols * tileW + (cols - 1) * gap;
    const startX = cx - totalW / 2 + tileW / 2;
    const startY = cy - 40;

    games.forEach((g, i: number) => {
      const col = i % cols;
      const row = Math.floor(i / cols);
      const x = startX + col * (tileW + gap);
      const y = startY + row * (tileH + gap);

      const bg = this.add
        .rectangle(x, y, tileW, tileH, 0xb8e6d0)
        .setStrokeStyle(4, 0xffffff)
        .setInteractive({ useHandCursor: true });
      const icon = this.add
        .text(x, y - 22, GAME_ICONS[g.id], { fontSize: '42px' })
        .setOrigin(0.5);
      const label = this.add
        .text(x, y + 32, g.namePl, {
          fontFamily: 'system-ui, sans-serif',
          fontSize: '15px',
          color: '#4a3f55',
          fontStyle: 'bold',
          align: 'center',
          wordWrap: { width: tileW - 16 },
        })
        .setOrigin(0.5);

      // data na E2E
      bg.setData('gameId', g.id);

      const fire = () => {
        this.tweens.add({
          targets: [bg, icon, label],
          scaleX: 0.94,
          scaleY: 0.94,
          duration: 90,
          yoyo: true,
          onComplete: () => launchConsoleGame(g.id),
        });
      };
      bg.on('pointerdown', fire);
    });

    UiKit.button(this, {
      x: cx,
      y: this.gameH - 100,
      label: 'Wróć do domku',
      width: 240,
      height: MIN_TOUCH,
      fill: 0xffb6c1,
      onClick: () => getSceneRouter().go('House'),
    });

    this.registry.set(
      'consoleGames',
      games.map((g) => g.id as string),
    );
  }
}

export default ConsoleHubScene;
